import { type FC } from 'react';


import { type IconProps } from './types';

export const ArrowsProtect2InV4Icon: FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M33 34H63V64" stroke="#FFDD00" strokeWidth="2" />
      <path d="M31 1L1 1L1 31" stroke="#FFDD00" strokeWidth="2" />
    </svg>
  );
};
